import { getFrontMenuList } from "@/api/back.js";
const { selectedKeys, routerPath } = { selectedKeys: ["首页"], routerPath: "" }; // 用户的菜单使用缓存
const state = {
  menuList: [
    { title: "首页", routerPath: "" },
    { title: "中心简介", routerPath: "" },
    { title: "信息服务", routerPath: "" },
    { title: "资源导航", routerPath: "" },
  ],
  selectedKeys,
  curMenuRouterPath: routerPath,
  updateMenuList: [],
};
const getters = {
  stateMenuList: (state) => state.menuList,
  stateSelectedKeys: (state) => state.selectedKeys, // 当前选中的item
  stateRouterPath: (state) => state.curMenuRouterPath, // 当前路由
  stateMenuChildren: (state) => state.menuChildren, // 当前路由
  setUpdateMenuList: (state) => state.updateMenuList,
};
const mutations = {
  updateMenuItemStatus: (state, params) => {
    const { selectedKeys, routerPath } = params;
    state.selectedKeys = selectedKeys;
    state.routerPath = routerPath;
    // setStorage('menuUsedStorage', params, 0)
  },
  updateMenuList: (state, params) => {
    state.updateMenuList = params.list;
  },
};
const actions = {
  // eslint-disable-next-line no-unused-vars
  setMenu: ({ state, commit }, params) => {
    getFrontMenuList().then((res) => {
      params.forEach((item) => {
        res.data.forEach((ele) => {
          if (item.code === ele.code) {
            item.title = ele.label;
            item.tips = ele.englishName;
            item.id = ele.id;
            item.status = ele.status;
            item.children = ele.children || [];
            item.isShow = true;
          }
        });
        commit("updateMenuList", { list: res.data });
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
